<div class="assistant-chat">
  <div class="assistant-chat__messages" #messagesContainer>
    @if (messages.length === 0 && !uiState.isLoading) {
      <div class="assistant-chat__welcome">
        <div class="assistant-chat__welcome-icon">🤖</div>
        <h4>{{ 'assistantPage.chat.welcomeTitle' | translate }}</h4>
        <p>{{ 'assistantPage.chat.welcomeMessage' | translate }}</p>
      </div>
    }

    @for (msg of messages; track trackByMessageId($index, msg)) {
      <app-chat-message [message]="msg"></app-chat-message>
    }

    @if (uiState.isLoading) {
      <app-chat-typing-indicator></app-chat-typing-indicator>
    }
  </div>

  @if (uiState.error) {
    <div class="assistant-chat__error">
      <span class="assistant-chat__error-text">⚠️ {{ uiState.error }}</span>
      <button class="assistant-chat__error-retry" (click)="retry()" type="button">
        {{ 'assistantPage.chat.retry' | translate }}
      </button>
      <button class="assistant-chat__error-dismiss" (click)="dismissError()" type="button" aria-label="{{ 'assistantPage.chat.dismissErrorAria' | translate }}">✕</button>
    </div>
  }

  <app-chat-input [disabled]="uiState.isLoading" (sent)="onSend($event)"></app-chat-input>
</div>
